export default __webpack_public_path__ + "static/media/noa-2.0e35dd3d.jpg";